<template>
    <div class="skill-assessment">
        <el-table
            :data="tableData"
            style="
                width: 100%;
                flex: 1;
                border: 1px solid #f2f4f7;
                border-radius: 4px;
            "
            size="medium"
            :header-cell-style="{
                fontWeight: 'normal',
                color: '#333',
                background: '#f5f7fa',
            }"
            class="table-content"
            :cell-style="{ fontSize: '12px', color: '#333' }"
        >
            <el-table-column type="index" label="序号" width="50"> </el-table-column>

            <el-table-column label="姓名">
                <template slot-scope="scope">{{ scope.row.s_name }}</template>
            </el-table-column>

            <el-table-column label="提交时间">
                <template slot-scope="scope">{{ scope.row.time }}</template>
            </el-table-column>

            <el-table-column label="评定状态" v-if="role !== 4">
                <template slot-scope="scope">
                    <span :class="{ fail: scope.row.status === 2 }">{{ scope.row.status === 1 ? "已提交" : scope.row.status === 0?'未提交':"打回重做" }}</span>
                </template>
            </el-table-column>

            <!-- 学生得分列 -->
            <el-table-column label="得分" v-if="role === 4">
                <template slot-scope="scope">
                    {{ scope.row.teacher_status === 0 || scope.row.status !== 1 ? "-" : scope.row.teacher_score }}
                </template>
            </el-table-column>

            <!-- 教师得分打分列 -->
            <el-table-column label="得分" v-if="role !== 4">
                <template slot-scope="scope">
                    <div class="table-scoring" v-if="scope.row.status === 1">
                        <!-- <el-input-number
                            v-model="scope.row.teacher_score"
                            controls-position="right"
                            :precision="2"
                            :min="0"
                            :max="100"
                            size="small"
                        ></el-input-number>
                        <el-button slot="trigger" size="small" type="primary" @click="confirmScore(scope.row)">确定</el-button> -->
                        {{ scope.row.teacher_score }}
                    </div>

                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <div class="table-operate">
                        <el-button type="text" @click="handleAssessmentDetail(scope.row)" v-if="scope.row.status === 1">查看</el-button>
                        <span v-else>-</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                :current-page="pageParams.page"
                :page-size="pageParams.size"
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next, total"
                :total="pageParams.total"
            >
            </el-pagination>
        </div>

        <SkillAssessmentDetailDialog
            :id="dialogData.p_id"
            :project-id="dialogData.id"
            :student-id="dialogData.s_id"
            :visible="dialogData.visible"
            :is-operate="true"
            :analysis="analysis"
            @close="closeDialog"
            @update="getSkillAssessmentList"
            @preview="previewSource"
        ></SkillAssessmentDetailDialog>

        <div class="preview-box" v-if="previewUrl && !loading">
            <ElImageViewer class="preview-img" :url-list="[previewUrl]" alt="" v-if="['jpg', 'png'].includes(getFileExtensiion)" />

            <i class="el-icon-close" @click="closePreview"></i>
        </div>
    </div>
</template>

<script>
import SkillAssessmentDetailDialog from "./SkillAssessmentDetailDialog.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "SkillAssessment",
    props: {
        analysis: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tableData: [],
            pageParams: {
                page: 1,
                size: 10,
                paging: 1,
                total: 0,
            },
            role: Number(localStorage.getItem("role")),
            dialogData: {
                p_id: undefined,
                id: undefined,
                s_id: undefined,
                visible: false,
            },
            previewUrl: "", // 预览文件名路径
            previewSrc: null, // 预览文件src
            loading: null,
        };
    },
    components: {
        SkillAssessmentDetailDialog,
        ElImageViewer,
    },
    created() {
        this.getSkillAssessmentList();
    },
    computed: {
        // 获得文件扩展名
        getFileExtensiion() {
            const fileExtension = this.previewUrl?.slice(((this.previewUrl.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return fileExtension;
        },
    },
    watch: {},
    methods: {
        getSkillAssessmentList() {
            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(this.$route.query.zhangIndex),
                course_node: Number(this.$route.query.jieIndex),
                project_id: Number(this.$route.query.id),
                page: this.pageParams.page,
                limit: this.pageParams.size,
                type:Number(localStorage.getItem("project_type"))
            };
           
            // if(Number(localStorage.getItem("project_type"))==3){
            //         delete params.course_id
            //         delete params.course_chapter
            //         delete params.course_node
            //     }
            if (this.role !== 4) params.c_id = Number(localStorage.getItem("class_id"));

            this.$shttp.axiosGetBy(this.$api.training_assessment_list, params, (res) => {
                if (res.code === 200) {
                    this.tableData = res.data.list || [];
                    this.pageParams.total = res.data.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;
            this.getSkillAssessmentList();
        },

        // 查看评价详情
        handleAssessmentDetail(row) {
            if (row.status !== 1) {
                this.$message.warning("学生暂未提交");
                return;
            }
        let role=localStorage.getItem("role")

            this.$router.push({path:role==4?"/student/qualityCourse/scoreBreakdown":'/qualityCourse/scoreBreakdown',query:{s_id:row.s_id,...this.$route.query}})

            // this.dialogData.p_id = row.id;
            // this.dialogData.id = this.$route.query.id;
            // this.dialogData.s_id = row.s_id;
            // this.dialogData.visible = true;
        },

        // 教师打分
        confirmScore(row) {
            const params = {
                id: row.id,
                score: row.teacher_score,
                // comment: row.comment || "",
            };

            this.$shttp.axiosPost(this.$api.training_score, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                }
            });
        },

        // 关闭弹框
        closeDialog() {
            this.dialogData.p_id = undefined;
            this.dialogData.s_id = undefined;
            this.dialogData.id = undefined;
            this.dialogData.visible = false;
        },

        // 预览文件
        previewSource(url) {
            this.previewUrl = url;
        },

        // 关闭文件预览
        closePreview() {
            this.previewSrc = null;
            this.previewUrl = "";
        },

        onFileLoad(error) {
            console.log("preview error: ", error);
        },
    },
};
</script>

<style scoped lang="scss">
.skill-assessment {
    padding: 20px;

    .fail {
        color: #ff2626;
    }

    .table-scoring {
        display: flex;
        gap: 5px;

        .el-input-number--small {
            width: 110px;
        }
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
    }

    ::v-deep .el-dialog {
        position: absolute;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 90vh;
        overflow: hidden;

        .el-dialog__header {
            padding: 15px 20px;
        }

        .el-dialog__body {
            padding: 0;
        }
    }

    .preview-box {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.3);

        ::v-deep .el-image-viewer__wrapper {
            .el-image-viewer__mask {
                display: none;
            }

            .el-icon-circle-close {
                display: none;
            }

            .el-image-viewer__canvas img {
                width: 40% !important;
                height: auto !important;
            }
        }

        .el-icon-close {
            position: absolute;
            right: 50px;
            top: 30px;
            font-size: 40px;
            cursor: pointer;
            color: #ffffffda;
            z-index: 9999;
        }
    }
}
</style>
